import React, { useEffect, useState } from 'react';

import Styles from './styles';

import 'components/ModelButton/styles.scss';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from 'store/ducks';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import Loading from 'components/Loading';
import Animated from 'components/Animated';
import { DataCustomer } from 'components/DataCustomer';
import { LegalDocuments } from 'components/LegalDocuments';
import CustomerService from 'services/customer.service';

const CustomerData: React.FC = () => {
  const customer = useSelector((state: RootState) => state.customer);
  const user = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();
  const [dataCustomer, setDataCustomer] = useState(customer);

  const _customerService = new CustomerService();

  const getCustomerData = async (id: string) => {
    const response = await _customerService.findById(id);

    setDataCustomer(response.data);
  };

  useEffect(() => {
    if (user && user?.userType === 'customer' && user.selectedCustomerId) {
      getCustomerData(user.selectedCustomerId);
    } else if (
      (user && user?.userType === 'customer' && !user.selectedCustomerId) ||
      (user && user.userType === 'employee')) {
      navigate('/dashboard');
    }
  }, [user]);

  useEffect(() => {
    const element = document.body;

    element.classList.add('background-body-customer');

    return () => {
      element.classList.remove('background-body-customer');
    };
  }, []);

  return (
    <>
      <Animated
        show={!dataCustomer?.companyName}
        animationIn="none"
        animationInDelay="faster"
        animationOut="fadeOut"
        animationOutDelay="faster"
        className={`fixed top-0 right-0 bottom-0 left-0 d-flex align-center justify-center z-999 ${!dataCustomer?.companyName && 'bg-white'}`}
      >
        <Loading size={45} />
      </Animated>
      {dataCustomer?.companyName && (
        <>
          <Styles.CustomerWrapper>
            <Row className="flex-1 flex-lg-column justify-between customer-header data-customer-header">
              <Row className="align-center flex-lg-column align-lg-none w-70 w-sm-100">
                <Text
                  size={36}
                  className="color-primary font-bold customer-header--name"
                >
                  {dataCustomer?.companyName}
                </Text>
                <Text
                  size={12}
                  className="ml-3 ml-sm-0 color-blue-gray font-italic text-wrap pr-1"
                >
                  Código Interno {dataCustomer?.identifier} {dataCustomer?.crmCustomerCode && '| Código Cliente '}{' '}
                  {dataCustomer?.crmCustomerCode}
                </Text>
              </Row>
            </Row>

            {
              <Animated
                show
                animationIn="slideInUp"
                animationInDelay="faster"
                animationOut="none"
                animationOutDelay="faster"
              >
                <Column
                  className="bg-white mx-3 px-3 pb-3 customer-content"
                  style={{ borderRadius: '10px 10px 0 0' }}
                >
                  <Row className="my-4 flex-1 flex-lg-column">
                    <DataCustomer customer={dataCustomer} />

                    <div className='w-50 w-lg-100'>
                      <LegalDocuments legalDocumentsAttachments={dataCustomer.legalDocuments} />
                    </div>
                  </Row>
                </Column>
              </Animated>
            }
          </Styles.CustomerWrapper>
        </>
      )}
    </>
  );
};

export default CustomerData;
